import { render, staticRenderFns } from "./AppStoreButton.vue?vue&type=template&id=e9c940ca&scoped=true&"
import script from "./AppStoreButton.vue?vue&type=script&lang=js&"
export * from "./AppStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreButton.vue?vue&type=style&index=0&id=e9c940ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c940ca",
  null
  
)

export default component.exports